export const WALKTHROUGH_QUESTIONS = {
  essentialAggrements: [
    "Teacher uses gender-neutral vocabulary and is sensitive to caste/class/gender in society.",
    "Teacher has established classroom rules and procedures, clear to both teacher and learners.",
    "Learners speak only when permitted (control with teacher).",
    "Student misbehavior is addressed promptly to maintain class focus.",
    "Teacher manages support roles well, including responses, praise, and decorum.",
  ],
  planingAndPreparation: [
    "Teacher displays extensive and deep knowledge of her discipline.",
    "Teacher's approach is interdisciplinary and contextual.",
    "Learning Outcomes are clear, actionable and permit viable methods of assessment.",
    "Teacher's conduct of the lesson is aligned with the expected Learning Outcomes.",
    "Teacher has adequate audio-visual aids / resources to share with the learners.",
    "Teacher creates opportunities for students to refer to text book, presentations and other required resources.",
    "Timings were managed well throughout the class.",
  ],
  classRoomEnvironment: [
    "Classroom interactions among the teacher and individual students are highly respectful; active listening is encouraged.",
    "Teacher displays awareness of her students' backgrounds, cultures, skills, knowledge proficiency, interests and special needs.",
    "Teacher ensures that all students receive opportunities to respond to questions.",
    "Student thinking is visible through display of responses and doubts.",
    "Teacher uses positive reinforcement in the form of smileys, stickers and verbal appreciation.",
  ],
  instruction: [
    "Appropriate Pre-Read/Pre-Watch was assigned as prior knowledge test.",
    "Teacher's instructions are clear and well paced.",
    "Teacher's instruction is coherent and takes students from surface to deep learning.",
    "Teacher has included BIG Question, Think lines and HOTS to stimulate and challenge student thinking.",
    "Questions/situations posed by the teacher relate to children's real life context or lend to invoking responses from children's experience.",
    "Self and Peer Assessment by students is used to monitor progress.",
    "Activities/Assessment are fully aligned with learning outcomes.",
    "Instruction is differentiated appropriately.",
    "Teacher provides good Feed forward such that it enables student learning.",
    "Teacher recapitulates the lesson /topic and checks for the attainment of the learning outcomes.",
  ],
  ObserverFeedback: [
    "What went well?",
    "Areas that need work",
  ],
  TeacherFeedback: [
    "What went well?",
    "Areas that need work",
  ],
};

export default WALKTHROUGH_QUESTIONS;

